/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { first, map, of, Subject } from "rxjs";
import { Team } from "../../../../../concept/team";
import { TeamMember, teamMemberProperties } from "../../../../../concept/user";
import { DialogResult } from "../../../../../service/dialog.service";
import { TeamApi } from "../../../../../service/team/team-api.service";
import { SnackbarService } from "../../../../../service/snackbar.service";
import { FormActionsComponent, FormComponent, FormOption, FormSelectComponent, ModalComponent, requiredValidator } from "typedb-cloud-framework";
import { AccessLevel, accessLevelToString, accessLevelValues } from "../../../../../concept/iam";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from '@angular/material/autocomplete';

export type TeamAddAdminDialogData = { team: Team };

@Component({
    selector: "tp-team-add-admin-user-dialog",
    templateUrl: "./team-add-admin-user-dialog.component.html",
    imports: [
        ModalComponent, AsyncPipe, FormActionsComponent, FormsModule, ReactiveFormsModule, FormComponent,
        FormActionsComponent, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
    ]
})
export class TeamAddAdminUserDialogComponent {
    readonly isSubmitting$ = new Subject<boolean>();
    readonly form = this.formBuilder.nonNullable.group({
        user: [null as TeamMember | null, [requiredValidator]],
    });
    readonly accessLevelOptions: FormOption<AccessLevel>[] = accessLevelValues.map(x => ({ value: x, viewValue: accessLevelToString(x) }));
    readonly members$ = this.teamService.listMembers(
        this.data.team.uuid,
        {
            pagination: { offset: 0, limit: 1000 },
            sorting: { attributeType: "email" },
            filters: [ { property: teamMemberProperties.accessLevel, operator: "neq", value: { string: "admin" } } ]
        },
        of(undefined),
    ).pipe(first(x => !!x.initial), map(x => x.initial));

    constructor(
        private dialogRef: MatDialogRef<TeamAddAdminUserDialogComponent, DialogResult>, private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public  data: TeamAddAdminDialogData,
        private teamService: TeamApi, private snackbar: SnackbarService
    ) { }

    get submitDisabled(): boolean {
        return !this.form.value.user?.uuid
    }

    displayUser(user: TeamMember) {
        return user.email;
    }

    submit() {
        this.teamService.setMemberAccessLevel({ teamUuid: this.data.team.uuid, userUuid: this.form.value.user!.uuid, accessLevel: "admin" }).subscribe({
            next: () => {
                this.snackbar.success(`${this.form.value.user!.email}'s access level to ${this.data.team.id} updated to 'admin'.`);
                this.close("ok");
            },
            error: () => this.isSubmitting$.next(false),
        });
    }

    close(result?: DialogResult) {
        this.dialogRef.close(result);
    }
}
